import { render, staticRenderFns } from "./Su2Questions.vue?vue&type=template&id=e2a0a91c&scoped=true"
import script from "./Su2Questions.vue?vue&type=script&lang=js"
export * from "./Su2Questions.vue?vue&type=script&lang=js"
import style0 from "./Su2Questions.vue?vue&type=style&index=0&id=e2a0a91c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a0a91c",
  null
  
)

export default component.exports